module.exports = globalThis.WebLinksAddon